export default __webpack_public_path__ + "static/media/icon-pin.15c41889.svg";